export function setMobileCssBodyClass(): void {
  document.body.classList.remove('desktop');
  document.body.classList.add('mobile');
}

export function setDesktopCssBodyClass(): void {
  document.body.classList.remove('mobile');
  document.body.classList.add('desktop');
}
